import { address_list, add_address } from "@/api/order/order";
import {
  list as shopAddressList,
  save as shopAddressSave,
  update as shopAddressUpdate,
  del as shopAddressDel,
} from "@/api/upms/address";
import { update as shopPasswordUpdate } from "@/api/upms/password";
import { load_member } from "@/api/upms/profile";
import { search as goodsSearch } from "@/api/goods/goods";
import {
  list as goodsFavoriteList,
  add as goodsFavoriteAdd,
  del as goodsFavoriteDel,
} from "@/api/upms/goods_favorite";
import {
  list as storeFavoriteList,
  add as storeFavoriteAdd,
  del as storeFavoriteDel,
} from "@/api/upms/store_favorite";
import { view as messageView, send_entity as messageSend } from "@/api/upms/message";

const defaultPageInfo = { pageNum: 1, pageSize: 20 };

/** 兼容多种分页 / 列表响应 */
function unwrapPagePayload(res) {
  const outer = res && res.data;
  if (!outer) return { pageList: [], pageInfo: {} };
  if (Array.isArray(outer.pageList)) {
    return { pageList: outer.pageList, pageInfo: outer.pageInfo || {} };
  }
  const inner = outer.data;
  if (inner && Array.isArray(inner.pageList)) {
    return { pageList: inner.pageList, pageInfo: inner.pageInfo || {} };
  }
  if (inner && Array.isArray(inner.content)) {
    return { pageList: inner.content, pageInfo: inner };
  }
  if (Array.isArray(inner)) {
    return { pageList: inner, pageInfo: {} };
  }
  return { pageList: [], pageInfo: {} };
}

/** 订单侧 address_list：R.ok(List) → body.data 为数组 */
function extractOrderAddressList(res) {
  const d = res && res.data && res.data.data;
  if (Array.isArray(d)) return d;
  if (d && Array.isArray(d.content)) return d.content;
  return [];
}

function normalizeAddressRows(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return list.map((item) => ({
    ...item,
    contacts: item.contacts != null ? item.contacts : item.consignee,
  }));
}

/** 商品搜索：与 searchGoodsPage 一致 data.data.data.content */
function extractGoodsSearchPage(res) {
  const page = res && res.data && res.data.data && res.data.data.data;
  const content = page && Array.isArray(page.content) ? page.content : [];
  const pageable = (page && page.pageable) || {};
  return {
    pageList: content,
    pageInfo: {
      pageNum: pageable.pageNumber,
      totalElements: page != null ? page.total : 0,
    },
  };
}

export const userMoule = {
  namespaced: true,
  state: () => ({
    addressList: [],
    defaultAddress: {},
    currentIndex: 0,
    paySelectAddress: {},
    userBalance: "0",
    serachResultList: [],
    collectGoodsList: [],
    collectSellerList: [],
    messageList: [],
    unreadMessage: 0,
  }),
  mutations: {
    updateAddressList(state, data) {
      const pageList = normalizeAddressRows(data.pageList || []);
      state.addressList = [...pageList];
      const def =
        pageList.find(
          (item) => item.isDefault === true || item.isDefault === 1
        ) || pageList.find((item) => item.use === 1);
      state.defaultAddress = def || pageList[0] || {};
    },
    updatePaySelectAddress(state, data) {
      state.paySelectAddress = { ...data };
    },
    updateUserBalance(state, data) {
      state.userBalance = data.money;
      localStorage.setItem("userBalance", data.money);
    },
    updateSerachResultList(state, data) {
      state.serachResultList = [...(data.pageList || [])];
    },
    updateCollectGoodsList(state, data) {
      state.collectGoodsList = [...(data.pageList || [])];
    },
    updateCollectSellerList(state, data) {
      state.collectSellerList = [...(data.pageList || [])];
    },
    updateMessageList(state, data) {
      state.messageList = Array.isArray(data) ? [...data] : [];
    },
    updateUnreadMessage(state, data) {
      state.unreadMessage = data;
    },
  },
  actions: {
    async requestAddressList({ commit }, params = {}) {
      try {
        let rows = extractOrderAddressList(await address_list(params));
        if (!rows.length) {
          const r2 = await shopAddressList({
            pageNumber: 1,
            pageSize: 50,
            ...params,
          });
          rows = unwrapPagePayload(r2).pageList;
        }
        commit("updateAddressList", { pageList: rows });
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestAddressEdit({ dispatch }, params = {}) {
      try {
        const payload = { ...params };
        if (Object.prototype.hasOwnProperty.call(payload, "use")) {
          payload.isDefault = Boolean(payload.use);
          delete payload.use;
        }
        await shopAddressUpdate(payload);
        await dispatch("requestAddressList");
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestAddressAdd({ dispatch }, params = {}) {
      try {
        if (params.regionId != null && params.consignee != null) {
          await add_address(params);
        } else {
          await shopAddressSave(params);
        }
        await dispatch("requestAddressList");
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestAddressDel({ dispatch }, params = {}) {
      try {
        const id = params && (params.id != null ? params.id : params);
        await shopAddressDel(id);
        await dispatch("requestAddressList");
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestUpdateLoginPasswordList(context, params = {}) {
      try {
        await shopPasswordUpdate(params);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestGetUserBalanceList({ commit }, params = {}) {
      try {
        const res = await load_member(params);
        const member = res && res.data && res.data.data && res.data.data.member;
        let money = "0";
        if (member) {
          const v =
            member.availableBalance != null
              ? member.availableBalance
              : member.balance;
          money = v != null ? String(v) : "0";
        }
        commit("updateUserBalance", { money });
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestSetSafePasswordList(context, params = {}) {
      console.warn(
        "[user] requestSetSafePasswordList: no shop API mapped",
        params
      );
      return Promise.resolve();
    },
    async requestUpdateSafePasswordList(context, params = {}) {
      console.warn(
        "[user] requestUpdateSafePasswordList: no shop API mapped",
        params
      );
      return Promise.resolve();
    },
    async requestSearchResultList({ commit }, params = {}) {
      try {
        const merged = { ...defaultPageInfo, ...params };
        const res = await goodsSearch({
          keyword: merged.keyword,
          pageNumber: merged.pageNum ?? merged.pageNumber ?? 1,
          pageSize: merged.pageSize ?? 12,
          orderType: merged.orderType,
          storeId: merged.storeId,
          type: merged.type,
          storeType: merged.storeType,
          brandId: merged.brandId,
          goodsLabelId: merged.goodsLabelId,
          marketingId: merged.marketingId,
          startPrice: merged.startPrice,
          endPrice: merged.endPrice,
          isOutOfStock: merged.isOutOfStock,
        });
        const payload = extractGoodsSearchPage(res);
        commit("updateSerachResultList", payload);
        return Promise.resolve(payload);
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectGoodsList({ commit }, params = {}) {
      try {
        const result = await goodsFavoriteList({
          ...defaultPageInfo,
          ...params,
        });
        const payload = unwrapPagePayload(result);
        commit("updateCollectGoodsList", payload);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectSellerList({ commit }, params = {}) {
      try {
        const result = await storeFavoriteList({
          ...defaultPageInfo,
          ...params,
        });
        const payload = unwrapPagePayload(result);
        commit("updateCollectSellerList", payload);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectSellerAdd(context, params = {}) {
      try {
        await storeFavoriteAdd(params);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectSellerDel(context, params = {}) {
      try {
        const id = params && (params.id != null ? params.id : params);
        await storeFavoriteDel(id);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectGoods(context, params = {}) {
      try {
        await goodsFavoriteAdd(params);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestCollectGoodsDel(context, params = {}) {
      try {
        let id;
        if (params != null && typeof params === "object") {
          id =
            params.sellerGoodsId != null ? params.sellerGoodsId : params.id;
        } else {
          id = params;
        }
        await goodsFavoriteDel(id);
        return Promise.resolve();
      } catch (error) {
        console.error("error", error);
        return Promise.reject(error);
      }
    },
    async requestMessageList({ commit }, params = {}) {
      try {
        const result = await messageView(params);
        const d = result && result.data && result.data.data;
        const list = Array.isArray(d)
          ? d
          : Array.isArray(result && result.data)
            ? result.data
            : [];
        commit("updateMessageList", list);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
    async requestUnreadMessageList() {},
    async requestSendMessage(context, params = {}) {
      try {
        await messageSend(params);
        return Promise.resolve();
      } catch (error) {
        console.error(error);
        return Promise.reject(error);
      }
    },
  },
  getters: {
    addressList: (state) => state.addressList,
    defaultAddress: (state) => state.defaultAddress,
    userBalance: (state) => state.userBalance,
    serachResultList: (state) => state.serachResultList,
    paySelectAddress: (state) => state.paySelectAddress,
    collectGoodsList: (state) => state.collectGoodsList,
    collectSellerList: (state) => state.collectSellerList,
    messageList: (state) => state.messageList,
    unreadMessage: (state) => state.unreadMessage,
  },
};
